import styled from "styled-components";

export const PeopleWrapper = styled.div`
  width: 90%;
  max-width: 1470px;
  margin: 6rem auto;
  padding: 5rem 0 0 0;

  .container {
    .heading-title {
      margin-bottom: 3rem;
      text-align: center;
      margin-bottom: 0;
      letter-spacing: 2px;

      h3 {
        font-weight: 600;
        text-transform: uppercase;
      }
    }

    .flex {
      margin: auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: auto auto;
      gap: 3rem;
      width: 100%;

      // first person = centered top
      .col-md-4:first-child {
        grid-column: 2 / span 1; // center in the middle column

        .team-member {
          .team-img {
            height: 340px;
            margin-top: 0.75rem;
            margin-bottom: 0.75rem;

            img {
              object-fit: contain;
              object-position: top center;
            }
          }
        }
      }

      // second to fourth = bottom row (left, center, right)
      .col-md-4:nth-child(2) {
        grid-column: 1;
      }
      .col-md-4:nth-child(3) {
        grid-column: 2;
      }
      .col-md-4:nth-child(4) {
        grid-column: 3;
      }

      .col-md-4 {
        width: 100%;
        margin-bottom: 20px;

        .team-member {
          overflow: hidden;

          .team-img {
            width: 100%;
            height: 280px;

            img {
              width: 100%;
              object-fit: cover;
              height: 100%;
            }
          }

          #new {
            height: 40%;
          }
        }

        .team-title {
          margin-top: 0.75rem;
          text-align: center;

          h4 {
            margin: 0 0 0.4rem;
          }

          p {
            margin: 0;
          }
        }
      }

      /* responsive */
      @media screen and (max-width: 999px) {
        grid-template-columns: repeat(2, 1fr);

        .col-md-4:first-child {
          grid-column: 1 / span 2; // top full-width
          justify-self: center;
        }
        .col-md-4:nth-child(2),
        .col-md-4:nth-child(3) {
          grid-column: auto;
        }
        .col-md-4:nth-child(4) {
          grid-column: 1 / span 2; // last card spans full row if needed
        }
      }

      @media screen and (max-width: 699px) {
        grid-template-columns: 1fr;

        .col-md-4:first-child,
        .col-md-4:nth-child(2),
        .col-md-4:nth-child(3),
        .col-md-4:nth-child(4) {
          grid-column: auto;
        }

        padding: 3rem 0;
      }
    }

    .flex4 {
      margin: auto;
      display: grid;
      grid-template-areas:
        "top top top"
        "bottom1 bottom2 bottom3";
      grid-template-columns: repeat(3, 1fr);
      width: 100%;
      gap: 3rem;

      .col-md-4 {
        width: 100%;
        margin-bottom: 20px;
        .team-member {
          overflow: hidden;
          .team-img {
            width: 100%;
            height: 280px;
            img {
              width: 100%;
              object-fit: cover;
              height: 100%;
            }
          }

          .lead-software-image {
            img {
              object-fit: contain;
              object-position: center;
            }
          }

          #new {
            height: 40%;
          }
        }

        .team-title {
          margin-top: 0.75rem;
          text-align: center;

          h4 {
            margin: 0 0 0.4rem;
          }

          p {
            margin: 0;
          }
        }
      }

      @media screen and (max-width: 999px) {
        grid-template-columns: repeat(3, 1fr);
        width: 100%;
      }

      @media screen and (max-width: 699px) {
        grid-template-columns: repeat(1, 1fr);
        padding: 3rem 0;
        width: 100%;
      }
    }

    .cent {
      text-align: center;
    }

    .flex4 {
      grid-template-columns: repeat(4, 1fr);

      @media screen and (max-width: 799px) {
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
      }

      @media screen and (max-width: 599px) {
        grid-template-columns: repeat(1, 1fr);
        padding: 3rem 0;
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 599px) {
    padding: 2.5rem 0;
    width: 98%;
  }
`;
